module.exports = __webpack_public_path__ + "img/150.92405c6f.jpg";